import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21ab8a09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fold" }
const _hoisted_2 = { class: "collapse_panel_content" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "content_component"
}
const _hoisted_6 = {
  key: 0,
  class: "content_tip"
}

import draggable from 'vuedraggable';
import { withDefaults, ref, defineAsyncComponent } from 'vue';
import { Collapse } from 'ant-design-vue';
import emitter from '@/utils/mitt';
import { CaretRightOutlined } from '@ant-design/icons-vue';
import CDelModal from '@/components/CDelModal.vue';
import { dragDrop } from '@/utils/format/dragDrop';

interface Props {
  component: any;
  Index: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Fold',
  props: {
    component: { default: Object },
    Index: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { component: any, Index: any };

const MyLive = defineAsyncComponent(() => import('./MyLive.vue'));
const MyArticle = defineAsyncComponent(() => import('./MyArticle.vue'));
const MyImages = defineAsyncComponent(() => import('./MyImages.vue'));
const Living = defineAsyncComponent(() => import('./Living.vue'));
const aCollapse = Collapse;
const aCollapsePanel = Collapse.Panel;



const activeKey = ref([0]);
// 拖入模块
const fold = ref({ ...props.component });
const addModule = (e: any, key: number) => {
  let nestedList = [...fold.value.tabsList[key].nestedList];
  if (nestedList.length > 1) {
    nestedList = nestedList.filter((res: any) => {
      const judge = res.type == 2 || res.type == 3 || res.type == 4 || res.type == 5;
      return judge;
    });
    nestedList.length == 2 ? nestedList.splice(e.newIndex, 1) : '';
    nestedList.length == 0 ? (nestedList = [{ id: 0 }]) : '';
    fold.value.tabsList[key].nestedList = nestedList;
  }
};
// 编辑模块内容
const getCustom = (item: any, index: number) => {
  const data = {
    type: item.type,
    index,
    item: props.component,
  };
  emitter.emit('custom', data);
};

// 重排模块
const resetModule = () => {
  emitter.emit('resetModule', true);
};

// 删除模块
const deleteModal = ref(false);
const deteleData = ref();
const daleteIndex = ref();
const deleteList = (element: any, index: number) => {
  deteleData.value = element;
  daleteIndex.value = index;
  deleteModal.value = true;
};
const closeModal = () => {
  deleteModal.value = false;
};
const deteleSelect = () => {
  emitter.emit('modalIndex', props.Index);
  fold.value.tabsList[daleteIndex.value].nestedList = [{ id: 0 }];
  deleteModal.value = false;
  emitter.emit('visualization', fold.value);
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", { class: "fold_title" }, _toDisplayString(props.component.title), 513), [
      [_vShow, !props.component.showTitle]
    ]),
    _createVNode(_unref(aCollapse), {
      class: _normalizeClass(["fold_collapse", props.component.style == 1 ? 'fold_collapse_two' : props.component.style == 2 ? 'fold_collapse_three' : '']),
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
      bordered: false,
      expandIconPosition: props.component.style == 1 ? 'left' : 'right'
    }, _createSlots({
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.tabsList, (item, index) => {
          return (_openBlock(), _createBlock(_unref(aCollapsePanel), {
            style: _normalizeStyle({
          '--defaultLabelColor':
            props.component.senior.defaultLabel == '0' ? '#F7F8FA' : props.component.senior.defaultLabelColor,
          '--defaultTextColor': props.component.senior.defaultText == '0' ? '#505D6F' : props.component.senior.defaultTextColor,
          '--selectLabelColor': props.component.senior.selectLabel == '0' ? '#00CCB0' : props.component.senior.selectLabelColor,
          '--selecttTextColor':
            props.component.senior.selecttText == '0'
              ? props.component.style == 1
                ? '#FFFFFF'
                : '#00CCB0'
              : props.component.senior.selecttTextColor,
        }),
            class: _normalizeClass(["fold_collapse_panel", 
          props.component.style == 1 ? 'fold_collapse_panel_two' : props.component.style == 2 ? 'fold_collapse_panel_three' : ''
        ]),
            key: index,
            header: item.title
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(draggable), {
                  class: _normalizeClass(item.nestedList[0].name ? '' : 'content_empty_draggable'),
                  list: item.nestedList,
                  group: { name: 'subassembly' },
                  "item-key": "id",
                  onAdd: ($event: any) => (addModule($event, index)),
                  onDrop: _unref(dragDrop)
                }, {
                  item: _withCtx(({ element }) => [
                    _createElementVNode("div", {
                      onClick: _withModifiers(($event: any) => (getCustom(element, index)), ["stop"])
                    }, [
                      (!element)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                        : _createCommentVNode("", true),
                      element
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (element.type == 2)
                              ? (_openBlock(), _createBlock(_unref(Living), {
                                  key: 0,
                                  component: element
                                }, null, 8, ["component"]))
                              : (element.type == 3)
                                ? (_openBlock(), _createBlock(_unref(MyArticle), {
                                    key: 1,
                                    component: element
                                  }, null, 8, ["component"]))
                                : (element.type == 4)
                                  ? (_openBlock(), _createBlock(_unref(MyImages), {
                                      key: 2,
                                      component: element
                                    }, null, 8, ["component"]))
                                  : (element.type == 5)
                                    ? (_openBlock(), _createBlock(_unref(MyLive), {
                                        key: 3,
                                        component: element
                                      }, null, 8, ["component"]))
                                    : _createCommentVNode("", true),
                            (item.nestedList[0].name)
                              ? (_openBlock(), _createBlock(_component_svg_icon, {
                                  key: 4,
                                  onClick: _withModifiers(($event: any) => (deleteList(element, index)), ["stop"]),
                                  class: "content_component_svg",
                                  "icon-class": "delete_circular_click"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1032, ["class", "list", "onAdd", "onDrop"]),
                (!item.nestedList[0].name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "请将模块拖入标签区域"))
                  : _createCommentVNode("", true),
                (!item.nestedList[0].name)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      onClick: _withModifiers(resetModule, ["stop"]),
                      class: "content_btn",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("添加模块")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["style", "class", "header"]))
        }), 128))
      ]),
      _: 2
    }, [
      (props.component.style !== 2)
        ? {
            name: "expandIcon",
            fn: _withCtx(({ isActive }) => [
              _createVNode(_unref(CaretRightOutlined), {
                rotate: isActive ? 90 : 0
              }, null, 8, ["rotate"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["class", "activeKey", "expandIconPosition"]),
    _createVNode(CDelModal, {
      visible: deleteModal.value,
      centered: "",
      close: closeModal,
      ok: deteleSelect
    }, null, 8, ["visible"])
  ]))
}
}

})